import React from 'react';
import { Creatable } from 'react-select';

import styles from './DropdownCreateable.css';

class DropdownCreateable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectInstance: 1,
    };
  }

  onChangeSelect = newval => {
    const {
      input: { value, onChange },
      onCreate,
      options,
      list,
    } = this.props;
    let isNew = true;
    options.forEach(cat => {
      if (cat.value === newval.value && typeof newval.value === 'number') {
        isNew = false;
      }
    });
    if (isNew) {
      onCreate(newval.value, list, value);
      onChange(newval.value);
    } else {
      onChange(newval.value);
    }
  };

  render() {
    const {
      input: { value },
      placeholder,
      options,
      disabled,
      isErrorable,
      meta,
      maxLength,
    } = this.props;
    const { touched, error } = meta;
    const selectProps = {
      addLabelText: '{label} (create new)',
      value,
      className: styles['select-dropdown'],
      placeholder,
      onChange: this.onChangeSelect,
      options,
      disabled,
      clearable: false,
      backspaceRemoves: false,
      promptTextCreator: label => `${label} (create new)`,
      onClose: () => {
        this.setState({ selectInstance: 1 - this.state.selectInstance });
      },
    };
    if (this.state.selectInstance === 1) {
      return (
        <div
          className={isErrorable && touched && error ? styles['has-error'] : ''}
        >
          <Creatable {...selectProps} inputProps={{ maxLength }} />
        </div>
      );
    }
    return (
      <span>
        <Creatable {...selectProps} inputProps={{ maxLength }} />
      </span>
    );
  }
}

export default DropdownCreateable;
